<template>
  <!-- 密码输入弹窗 -->
  <div class="pkg-password" ref="pkgPassword" :style="{ left: left + 'px', top: top + 'px' }">
    <div class="pkg-password-title">
      <span>{{ $t('请输入压缩包密码') }}</span>
      <span class="icon i-close" @click="close()" />
    </div>
    <div class="pkg-password-content">
      <el-input :type="inputType" v-model="password">
        <i slot="suffix" :class="inputIcon" @click="togglePassword" />
      </el-input>
      <div
        v-if="checkPwdInfo"
        class="check-pwd"
      >
        {{ checkPwdInfo }}
      </div>
    </div>
    <div class="pkg-password-footer">
      <button class="lv-bn lv-80 c-btn lv-rm-12" @click="close()">{{ $t('取消') }}</button>
      <button class="lv-bn lv-80 s-btn" @click="confirmPkg()">{{ $t('确定') }}</button>
    </div>
  </div>
</template>

<script>
import { getWidthOrHeight } from 'js/util/util'

export default {
  props: {
    showPasswordDialog: {
      type: Boolean,
    },
    checkPwdInfo: {
      type: String,
      default() {
        return ''
      },
    },
    pkgDialogVisible: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      password: '',
      resizeTimer: null,
      inputType: 'password',
      inputIcon: 'el-icon-view',
    }
  },
  methods: {
    togglePassword() {
      if (this.inputType === 'password') {
        this.inputType = 'text'
        this.inputIcon = 'el-icon-sunrise'
      } else {
        this.inputType = 'password'
        this.inputIcon = 'el-icon-view'
      }
    },
    close() {
      if (!this.pkgDialogVisible) {
        this.$emit('closePkgPreview')
      }
      this.reset()
      this.$emit('update:showPasswordDialog', false)
    },
    reset() {
      this.password = ''
      this.$emit('clearPassword')
      this.$emit('update:checkPwdInfo', '')
    },
    confirmPkg() {
      if (this.password === '') {
        this.$emit('update:checkPwdInfo', this.$t('密码不能为空'))
        return
      }
      this.$emit('confirmPkg', this.password)
    },
    setPos() {
      const $dialog = this.$refs.pkgPassword
      const elemH = getWidthOrHeight($dialog, 'height')
      const elemW = getWidthOrHeight($dialog, 'width')
      const winH = window.innerHeight || document.documentElement.clientHeight
      const winW = window.innerWidth || document.documentElement.clientWidth
      this.left = (winW - elemW) / 2
      this.top = (winH - elemH) / 2
    },
    resize() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(this.setPos, 100)
    },
  },
  mounted() {
    this.setPos()
    window.addEventListener('resize', this.resize.bind(this, this), false)
  },
}
</script>

<style lang="less" scoped>
@import '~less/button.less';
.pkg-password {
  position: fixed;
  z-index: 1000;
  box-sizing: border-box;
  width: 450px;
  height: 212px;
  padding: 24px;
  background: #fff;
  -webkit-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  .pkg-password-title {
    height: 24px;
    margin-bottom: 24px;
    line-height: 24px;
    span {
      display: inline-block;
      height: 24px;
      font-size: 18px;
      line-height: 24px;
      color: #1b2733;
    }
    .i-close {
      float: right;
      margin-top: 7px;
      margin-right: -7px;
      background-image: url(~image/close.svg);
      background-repeat: no-repeat;
    }
  }
  .pkg-password-content {
    .el-input__suffix-inner {
      display: inline-block;
      margin-top: 8px;
      margin-right: 5px;
      cursor: pointer;
      .el-icon-view,.el-icon-sunrise {
        line-height: 32px;
      }
    }
    .check-pwd {
      margin-top: 4px;
      color: #FD4147;
      font-size: 12px;
    }
  }
  .pkg-password-footer {
    position: absolute;
    right: 24px;
    bottom: 24px;
    .default-btn {
      margin-right: 10px;
    }
  }
}
</style>
